module.exports = __webpack_public_path__ + "static/media/formulaMass.1b2cb1e3.png";